import { create } from 'zustand';
import { getStorage } from './storage';

export const NATIVE_ANALYTICS_CONSENT_KEY = 'native-usage-analytics:v1';
let generation = 0;
let loading;

// Optional device preference, independent of AI sharing and account access.
// An absent, unreadable or older receipt never opts the user in.
export const useNativeAnalyticsConsent = create((set, get) => ({
  loaded: false,
  allowed: false,
  revision: 0,
  load: () => {
    if (get().loaded) return Promise.resolve();
    if (loading) return loading;
    const current = generation;
    loading = (async () => {
      let allowed = false;
      try {
        const receipt = JSON.parse(await getStorage().getItem(NATIVE_ANALYTICS_CONSENT_KEY));
        allowed = receipt?.version === 1 && receipt?.allowed === true;
      } catch (_) { /* Keep analytics off if storage is unavailable. */ }
      if (current === generation) set({ loaded: true, allowed });
    })().finally(() => { loading = null; });
    return loading;
  },
  choose: async allowed => {
    const current = ++generation;
    // Stop dispatch immediately, including while the preference is being saved.
    set({ loaded: true, allowed: false, revision: current });
    await getStorage().setItem(NATIVE_ANALYTICS_CONSENT_KEY,
      JSON.stringify({ version: 1, allowed: allowed === true }));
    if (current === generation) set({ allowed: allowed === true });
  },
}));

export function hasNativeAnalyticsConsent() {
  const state = useNativeAnalyticsConsent.getState();
  return state.loaded && state.allowed;
}
